import React, { useEffect, useState } from "react";
import { MaterialReactTable } from "material-react-table";
import axios from "axios";
import {
  Paper,
  Typography,
  Box,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import Navbar from "../../Navbar";
import { UrlApi } from "../../../services/apirest";
import { MRT_Localization_ES } from "material-react-table/locales/es"; //Tabla en español
import { logEventos } from "../../../services/services";
const diasOrden = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];

const traduccionDias = {
  Monday: "Lunes",
  Tuesday: "Martes",
  Wednesday: "Miércoles",
  Thursday: "Jueves",
  Friday: "Viernes",
};

function transformarDatosParaTabla(data) {
  const mapa = {};
  data.forEach(({ username, dia_semana, menu, activa }) => {
    if (!mapa[username]) {
      mapa[username] = { username };
      diasOrden.forEach(
        (dia) => (mapa[username][dia] = { menu: "", activa: 1 })
      );
    }
    mapa[username][dia_semana] = { menu, activa };
  });
  return Object.values(mapa);
}
const rrhh = localStorage.getItem("adminrrhh");
const idSucursal = localStorage.getItem("sucursal");
const user = localStorage.getItem("user");

const TablaPedidoSemana = () => {
  const [datos, setDatos] = useState([]);
  const [selectSucursal, setSelectSucursal] = useState(8);

  //solo para el select de sucursales de rrhh
  const handleChangeSucursal = (e) => {
    setSelectSucursal(e.target.value);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axios.get(
          `${UrlApi}/viandas/pedidos/semanal/sucursal`
        );
        let datosFiltrados = data.data;

        console.log("datosFiltrados:", datosFiltrados);

        //Para rrhh solo se le arma la tabla y se le muestran las dos sucursales
        if (rrhh === "1") {
          datosFiltrados = datosFiltrados.filter(
            (data) => data.id_sucursal === selectSucursal
          );
          const transformados = transformarDatosParaTabla(datosFiltrados);
          setDatos(transformados);
          console.log("datos filtrados rrhh:", datosFiltrados);

          return; // Evita seguir ejecutando el resto
        }
        // Si sucursal es "8", solo mostrar datos del usuario actual
        else if (idSucursal === "8") {
          datosFiltrados = datosFiltrados.filter(
            (item) =>
              item.id_sucursal === Number(idSucursal) && item.username === user
          );
          console.log("datos filtrados 8:", datosFiltrados);
        }
        //Si el ususario es parte de netizar muestra la semana de viandas de todos nosotros :p
        else if (idSucursal === "1000") {
          datosFiltrados = datosFiltrados.filter(
            (dato) => dato.id_sucursal === Number(idSucursal)
          );
          console.log("datos filtrados 1000:", datosFiltrados);
        }

        const transformados = transformarDatosParaTabla(datosFiltrados);
        setDatos(transformados);
      } catch (error) {
        console.error("Error al obtener los pedidos", error);
      }
    };

    fetchData();
  }, [selectSucursal]);

  const columns = [
    {
      accessorKey: "username",
      header: "Usuario",
      Cell: ({ cell }) => cell.getValue(),
      enableColumnFilter: false,
    },
    ...diasOrden.map((dia) => ({
      accessorKey: dia,
      header: traduccionDias[dia],
      enableColumnFilter: false,
      size: 200, // ⬅️ ANCHO mínimo sugerido
      Cell: ({ cell }) => {
        const value = cell.getValue(); // { menu, activa }
        const desactivado = value?.activa === 0;
        return (
          <Box
            sx={{
              backgroundColor: desactivado ? "#f0f0f0" : "transparent",
              color: desactivado ? "gray" : "black",
              fontStyle: desactivado ? "italic" : "normal",
              opacity: desactivado ? 0.6 : 1,
              borderRadius: 1,
              py: 1,
              my: "auto",
              textAlign: "left",
              wordBreak: "break-word", // 🔑 para romper palabras largas
              whiteSpace: "normal", // 🔑 permite que el texto haga salto de línea
              overflowWrap: "break-word", // 🔑 asegura que se divida en espacios
            }}
          >
            {value?.menu || "-"}
          </Box>
        );
      },
    })),
  ];

  const textoSucursal = idSucursal === "1000" ? "Netizar S.A." : "Casa Central";

  useEffect(() => {
  logEventos(
    "acceso al menú Semana de viandas",
   "Viandas",
    "resumen Semana de viandas",
     localStorage.getItem("user"));
}, []);

  return (
    <>
      <Navbar />

      <Box
        sx={{
          p: 4,
          backgroundColor: "#f5f5f5",
          borderRadius: "10px",
          boxShadow: 3,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 4,
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              fontSize: "32px",
              color: "#333",
              textShadow: "1px 1px 3px rgba(0, 0, 0, 0.1)",
            }}
          >
            Resumen Viandas {rrhh !== "1" ? textoSucursal : ""}
          </Typography>
          {rrhh === "1" && (
            <FormControl sx={{ minWidth: 200 }}>
              <InputLabel id="sucursal-label">Sucursal</InputLabel>
              <Select
                labelId="sucursal-label"
                value={selectSucursal}
                label="Sucursal"
                onChange={handleChangeSucursal}
              >
                <MenuItem value={8}>Casa Central</MenuItem>
                <MenuItem value={1000}>Netizar SA</MenuItem>
              </Select>
            </FormControl>
          )}
        </Box>

        <MaterialReactTable
          //enableColumnFilters={true} //opcion de filtrado por columnas
          enableGlobalFilter={true}  //guiilea creo que le falta esata propiedad para filtrar hacer tarea
          enableDensityToggle={false}
          columns={columns}
          enableColumnFilters={false}
          enableFilters={false}
          enableColumnActions={false} // 👈 Esto oculta los tres puntitos
          localization={MRT_Localization_ES}
          data={datos}
          initialState={{
            density: "compact",
            showGlobalFilter: true,
            globalFilter: rrhh === "1" ? "" : user, // valor por defecto en el buscador para facilitar la busqueda de sus viandas
          }}
          muiTableProps={{
            sx: {
              tableLayout: "fixed", // <-- Esto es CLAVE
              width: "100%",
              "& .MuiTableCell-root": {
                padding: "12px",
                fontSize: "14px",
                verticalAlign: "top",
                wordBreak: "break-word", // importante para que el texto no estire columnas
              },
            },
          }}
        />
      </Box>
    </>
  );
};

export default TablaPedidoSemana;
